// Общие колонки, есть на всех видах

import { KYB_SITE_ITEM_STATUS } from '../../../constants';

// eslint-disable-next-line import/prefer-default-export
export function commonColumns() {
  return {
    name: null,
    props: ['_id', 'pic'], // список полей для запроса к серверу
    rowStyle: (item) => {
      if (item.status === 0) return { color: 'rgba(255,0,0,0.5)' };
      return {};
    },
    columns: [
      {
        prop: '+status',
        name: 'Статус',
        sort: true,
        nowrap: true,
        prop2value: [KYB_SITE_ITEM_STATUS, 'id', 'name'],
      },
      {
        prop: '+year',
        name: 'Год',
        sort: true,
        nowrap: true,
      },
      {
        prop: '+name',
        name: 'Название',
        sort: true,
      },
      {
        prop: '+desc',
        name: 'Описание',
        sort: true,
      },
    ],
  };
}
